export default __webpack_public_path__ + "static/price_bg-83edf458cb179dd26e063d93985adefc.png";